import React from "react";
import agent from "../../../app/assets/images/homepage/agent.svg";

const ScalingProblemSection = ({ data }: { data?: any }) => {
  return (
    <section className="relative w-full bg-[#141414] md:min-h-[350px] xl:min-h-[450px] flex items-center py-5 overflow-hidden">
      
      {/* TOP GLOW (70% spread, sharp → fade) */}
      <div
  className="pointer-events-none absolute top-0 left-[15%] h-[220px] w-[70%]"
  style={{
    background:
      "linear-gradient(to bottom, rgba(34,156,255,0.55) 0%, rgba(34,156,255,0.18) 35%, rgba(34,156,255,0.05) 60%, rgba(34,156,255,0) 100%)",
    transform: "translateY(0%)",
    filter: "blur(30px)",
  }}
/>

      <div className="mx-auto w-full max-w-[1950px] px-6 relative z-10">
        
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-12 xl:gap-16 md:px-5 lg:px-20">
          
          {/* LEFT SIDE (Text) */}
          <div className="order-2 md:order-1 flex flex-col justify-center">
            
            <h2 className="text-white text-center md:text-left text-2xl md:text-xl xl:text-4xl font-semibold leading-tight">
              Most businesses automate tasks. Very few automate decisions.
            </h2>

            <p className="mt-3 md:mt-6 text-[#B5B5B5] text-center md:text-left text-sm lg:text-base 2xl:text-2xl xl:leading-relaxed">
              The bottleneck in scaling isn't headcount — it's operational intelligence.
              Disconnected tools, manual handoffs, and fragmented data pipelines cost
              growing companies 20–40% of their productive capacity. We architect the
              systems that close that gap: AI agents that reason and act, workflows that
              connect every layer of your stack, and infrastructure that gets smarter as
              your business grows.
            </p>

          </div>

          {/* RIGHT SIDE (Image) */}
          <div className="order-1 md:order-2 flex justify-center items-center">
            <img
              src={agent}
              alt="agent"
              className="w-full max-w-[320px] md:max-w-[420px] lg:max-w-[800px] object-contain"
            />
          </div>

        </div>

      </div>
    </section>
  );
};

export default ScalingProblemSection;